import { render, staticRenderFns } from "./usp-card.vue?vue&type=template&id=64649bbf"
import script from "./usp-card.vue?vue&type=script&lang=ts"
export * from "./usp-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports